import { Actions, ActionTypes } from '@appStore/account/actions';
import { Message } from '@model';

export interface State {
  loading: boolean;
  loaded: boolean;
  unreadCountLoading: boolean;
  unreadCountLoaded: boolean;
  unreadCount: number;
  data: Message[];
}

export const initialState: State = {
  loading: false,
  loaded: false,
  unreadCountLoading: false,
  unreadCountLoaded: false,
  unreadCount: 0,
  data: []
};

export function reducer(state = initialState, action: Actions): State {
  switch (action.type) {
    case ActionTypes.MessageLoadData:
      return { ...state, loaded: false, loading: true };

    case ActionTypes.MessageLoadDataSuccess:
      return { ...state, loaded: true, loading: false, data: action.payload };

    case ActionTypes.MessageLoadDataFail:
      return { ...state, loaded: false, loading: false };

    case ActionTypes.MessageLoadCount:
      return { ...state, unreadCountLoaded: false, unreadCountLoading: true };

    case ActionTypes.MessageLoadCountSuccess:
      return { ...state, unreadCount: action.payload, unreadCountLoaded: true, unreadCountLoading: false };

    case ActionTypes.MessageLoadCountFail:
      return { ...state, unreadCount: 0, unreadCountLoaded: false, unreadCountLoading: false };

    case ActionTypes.MessageSetAsReadSuccess:
      const newItem = action.payload;
      const newData = state.data.map(item => (item.id === newItem.id ? newItem : item));
      const newUnreadCount = newData.filter(i => i.isRead === false).length;
      return {
        ...state,
        data: newData,
        unreadCount: newUnreadCount
      };
  }
  return state;
}

export const getAll = (state: State) => state.data;
export const getLoaded = (state: State) => state.loaded;
export const getLoading = (state: State) => state.loading;
export const getUnreadCount = (state: State) => state.unreadCount;
export const getUnreadCountLoaded = (state: State) => state.unreadCountLoaded;
export const getUnreadCountLoading = (state: State) => state.unreadCountLoading;
